import React, { useEffect, useState } from "react";
import { Form, Input, Button, Drawer, Select, notification } from "antd";

import { create as CreateUser } from "../../api/User";
import { update as UpdateUser } from "../../api/User";

import { formatFirstname, formatLastname } from '../../utils';

import  { ROLES } from "./constants";

const { Option } = Select;

const layout = {
  labelCol: {
    span: 6,
  },
  wrapperCol: {
    span: 16,
    className: "mx-3"
  },
};

const UserForm = (props) => {
  const { user } = props;
  const [visible, setVisible] = useState(false);
  const [form] = Form.useForm();

  const onFinish = async () => {
    form.validateFields().then(async (values) => {
      if (user) {
        await UpdateUser(user.id, values);
      } else {
        await CreateUser(values);
      }

      props.onCreated();
      onClose();
    })
    .catch((error) => {
      notification['error']({
        message: "Pensez à bien compléter tous les champs requis."
      });
    });
  };

  const onFinishFailed = (errorInfo) => {
    form.resetFields();
    // @todo a implementé
    console.log("Failed:", errorInfo);
  };

  const onClose = () => {
    props.onClose();
    form.resetFields();
  };

  useEffect(() => {
    setVisible(props.visible);
  });

  let initialValues = {
    firstname: null,
    lastname: null,
    email: null,
    phone: null,
    mobile_phone: null,
    role_id: 1,
  };

  useEffect(() => {
    if (user) {
      initialValues = {
        firstname: formatFirstname(user.firstname),
        lastname: formatLastname(user.lastname),
        email: user.email,
        role_id: user.role_id,
        phone: user.phone,
        mobile_phone: user.mobile_phone,
      };
    }
    form.setFieldsValue(initialValues);
  }, [user]);

  let roleOptions = ROLES.map((option, index) => (
    <Option key={index} value={option.id}>{option.label}</Option>
  ));

  let drawerTitle = "Ajout d'un nouvel utilisateur";
  if (user) {
    drawerTitle = "Modification d'un utilisateur";
  }

  return (
    <Drawer
      title={drawerTitle}
      placement="left"
      closable={true}
      onClose={onClose}
      visible={visible}
      width="800px"
      key="left"
      footer={
        <div
          style={{
            textAlign: "right",
          }}
        >
          <Button onClick={onClose} style={{ marginRight: 8 }}>
            Annuler
          </Button>
          <Button onClick={onFinish} type="primary">
            Enregistrer
          </Button>
        </div>
      }
    >
      <Form
        {...layout}
        form={form}
        name="care_unit"
        initialValues={initialValues}
        onFinishFailed={onFinishFailed}
      >
        <Form.Item
          label="Prénom"
          name="firstname"
          rules={[{ required: true, message: 'Le prénom est obligatoire' }]}
        >
          <Input className="ant-input-text"/>
        </Form.Item>
        <Form.Item
          label="Nom"
          name="lastname"
          rules={[{ required: true, message: 'Le nom est obligatoire' }]}
        >
          <Input className="ant-input-text"/>
        </Form.Item>
        <Form.Item label="Email" name="email">
          <Input className="ant-input-text" type="email" />
        </Form.Item>
        <Form.Item label="Téléphone fixe" name="phone">
          <Input className="ant-input-text"/>
        </Form.Item>
        <Form.Item label="Téléphone portable" name="mobile_phone">
          <Input className="ant-input-text"/>
        </Form.Item>
        <Form.Item label="Rôle" name="role_id">
          <Select
            showSearch
            style={{ width: 250 }}
            placeholder="Sélectionnez un rôle"
            optionFilterProp="children"
          >
            {roleOptions}
          </Select>
        </Form.Item>
      </Form>
    </Drawer>
  );
};

export default UserForm;
